import { useEffect, useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { PartnerAPI } from "@/lib/partnerApi";

export default function FAQPanel() {
    const [faq, setFaq] = useState(null);
    const [open, setOpen] = useState(0);

    useEffect(() => {
        PartnerAPI.faq()
            .then((d) => setFaq(d.faq || []))
            .catch(() => setFaq([]));
    }, []);

    if (!faq) return null;

    return (
        <section data-testid="partner-faq-panel">
            <header>
                <span className="divider-rule text-gold">
                    <HelpCircle size={12} /> Partner FAQ
                </span>
                <h2 className="font-serif text-4xl text-cream mt-5">
                    Quick answers
                </h2>
                <p className="mt-3 text-cream/60 text-sm">
                    Common questions about your dashboard and workflow.
                </p>
            </header>
            <div className="mt-10 space-y-3">
                {faq.map((item, i) => {
                    const isOpen = open === i;
                    return (
                        <div
                            key={i}
                            data-testid={`faq-item-${i}`}
                            className="bg-cream/5 border border-cream/10 rounded-sm overflow-hidden backdrop-blur"
                        >
                            <button
                                type="button"
                                onClick={() => setOpen(isOpen ? -1 : i)}
                                className="w-full text-left px-5 py-4 flex items-center justify-between gap-4 hover:bg-cream/10 transition-colors"
                                data-testid={`faq-item-${i}-toggle`}
                            >
                                <span className="font-serif text-cream text-base md:text-lg flex-1">
                                    {item.q}
                                </span>
                                <ChevronDown
                                    size={16}
                                    className={`text-gold shrink-0 transition-transform ${
                                        isOpen ? "rotate-180" : ""
                                    }`}
                                />
                            </button>
                            {isOpen && (
                                <div
                                    className="px-5 pb-5 text-cream/75 leading-relaxed text-sm border-t border-cream/10 pt-4"
                                    data-testid={`faq-item-${i}-answer`}
                                >
                                    {item.a}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
